import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-plant-hire',
  templateUrl: './plant-hire.component.html',
  styleUrls: ['./plant-hire.component.css']
})
export class PlantHireComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/dev-man/Kgwetlwo-app/src/app/pages/services/plant-hire/plant-hire.component.ts